import { InjectionToken } from '@angular/core';

/**
 * A promise that resolves once `SuperTokens.init()` has completed.
 *
 * `thkee-common` HTTP interceptors and the SSE service need to wait
 * for SuperTokens to be initialised before invoking `Session.*` APIs,
 * but they can't import the marketplace-app's `AuthenticationService`
 * without creating a circular dependency. The token decouples them:
 *
 * - **Marketplace app** overrides this token in `app.config.ts` with
 *   the `superTokensReady` promise from `AuthenticationService`
 *   (which is what kicks off `ensureSuperTokensInit` in its
 *   constructor).
 *
 * - **Admin app / SSR / tests** fall back to the default factory
 *   (`Promise.resolve()`). Admin already initialises SuperTokens
 *   synchronously in `main.ts` BEFORE bootstrapping, so callers see
 *   "ready" by definition; the no-op default works there.
 *
 * Consumers do `await inject(SUPER_TOKENS_READY)` (or
 * `from(superTokensReady).pipe(switchMap(...))` in interceptors)
 * before calling `Session.doesSessionExist()` / `attemptRefreshing
 * Session()` etc.
 */
export const SUPER_TOKENS_READY = new InjectionToken<Promise<void>>('SUPER_TOKENS_READY', {
  providedIn: 'root',
  factory: () => Promise.resolve(),
});
